const resources_en = {
    EnterUsername: "Enter Username",
    EnterPassword: "Enter Password",
    Language: "Language",
    PriceFormatDecimal: "Decimal",
    PriceFormatFractional: "Fractional",
    PriceFormatAmerican: "American",
    More: "more",
    Account: "Account",
    AccountStatement: "Account Statement",
    AccountSummary: "Account Summary",
    Balance: "Balance",
    Aggregate: "Aggregate",
    AllSports: "A - Z Sports",
    AllSportsMultiples: "All Multiples",
    Sports: "Sports",
    AllMarkets: "All Markets",
    ApplyCode: "Apply Code",
    Answer: "Answer",
    AtTheOff: "At the Off",
    Back: "Back",
    BetCurrency: "Betting Currency",
    BetSlip: {
        "Accumulator": "Accumulator",
        "CancelAll": "Cancel All",
        "Done": "Done",
        "MultiplesTab": "Multiples",
        "PlaceBets": "Place Bet(s)",
        "PotentialReturn": "To Win",
        "Receipt": "Receipt",
        "ReUseSelections": "Reuse Selections",
        "Singles": "Singles",
        "Stake": "Stake",
        "TotalStake": "Total Stake",
        "StakeAllSingles": "Stake All Singles",
        "Standard": "Singles",
        "Teaser": "Teaser",
        "AcceptChangesAndPlaceBet": "Accept Changes & Place Bet(s)",
        "AcceptAndPlaceBet": "Accept & Place Bet(s)",
        "AcceptChangesAndContinue": "Accept Changes & Continue",
        "RemoveSelectionToContinue": "Please remove this selection to continue",
        "PriceChanged": "Price changed from {0} to {1}",
        "SelectionSuspended": "Sorry! {0} of your selection(s) are suspended",
        "BetCannotBePlaced": "Your bet(s) cannot be placed. Please contact Customer Services.",
        "NoSelectionPriceChange": "{0} of your selection(s) had a price change",
        "RaceWithdrawal": "This race had a withdrawal. Please review here",
        "NoSelectionNeedAttention": "{0} of your selection(s) need your attention",
        "NoPriceAvailableForCombination": "No price available for this combination",
        "MaxStakeAtPrice": "At this price, the max stake allowed is {0}",
        "SelectionsCannotBeCombined": "Some of the selections cannot be combined",
        "SelectionNotValidForFreeBet": "This selection is not valid for free Bet",
        "BetsNotValidForFreeBet": "Some of the bet(s) is not valid for free bets",
        "MaxAvailableStake": "Bet not placed, max available stake is {0}{1}",
        "BetsPlacedWithSuccess": "Success! Your bet(s) have been placed",
        "PicksPlacedWithSuccess": "Success! Your picks have been placed",
        "NoBetsNotPlaced": "Sorry! {0} of your bet(s) have not been placed",
        "BetNotPlaced": "This bet has not been placed",
        "StakeMustBeGreaterThan": "Stake must be greater than {0}",
        "TotalStakeMustBeGreaterThan": "Total stake must be greater than {0}",
        "MinStakePerLineAllowed": "The minimum stake per line allowed is {0}",
        "MinTotalStakeLineAllowed": "The minimum total stake allowed is {0}",
        "FreeBetsPlacedError": "No bets have been placed, since your Free Bet entitlements are not sufficient to cover the stake for the requested bets, or cannot be used for the requested bets." +
            "\n\nPlease try to place the bets from your regular betting funds instead, or reduce the stake.",
        "Bet": " Bet",
        "Bets": " Bets",
        "inValidExpiryTime": "Invalid date format.The date entered cannot be earlier than the current time.",
        "inValidExpiryMonth": "Invalid date format.\nThere are too many days in that month.",
        "Suspended": "SUSPENDED",
        "invalidOddsEntered": ["The odds you have entered are invalid. Please try again",
            "Prices between 6.00 and 10.00 must be a multiple of 0.10",
            "Prices between 10.00 and 20.00 must be a multiple of 0.50",
            "Prices between 20.00 and 50.00 must be a multiple of 1.00",
            "Prices between 50.00 and 200.00 must be a multiple of 2.00",
            "Prices between 200.00 and 1000.00 must be a multiple of 5.00",
            "The maximum price is 1000.00",
            "The Fractional odds you have entered are invalid. Please try again.",
            "The American odds you have entered are invalid. Please try again."],
        "Confirm": "Confirm"
    },

    BootstrapError:
        "There has been a problem loading your account details. Please try again. If the issue persists, please contact the customer service.",
    Cancel: "Cancel",
    CancelBet: "Cancel Bet",
    Casino: "Casino",
    ChangePref:
        "To change your preferences on receiving details of BETDAQ's free bets, special offers and promotions, please update your Personal Details in the My Account section of the main site.",
    City: "City/Town",
    ConfirmPass: "Confirm Password",
    ConfirmTerms: "I confirm that I am at least 18 years of age and that I accept the",
    Contact: "Contact Us",
    Continue: "Continue",
    Country: "Country",
    CountryTelCodes: {
        uk: "+44 - uk",
        ie: "+353 - ie",
        az: "+994 - az",
        bb: "+1-246 - bb",
        kh: "+855 - kh",
        co: "+57 - co",
        cr: "+506 - cr",
        cw: "+599 - cw",
        ec: "+593 - ec",
        fk: "+500 - fk",
        gh: "+233 - gh",
        gi: "+350 - gi",
        gg: "+44 - gg",
        iq: "+964 - iq",
        im: "+44 - im",
        je: "+44 - je",
        lb: "+961 - lb",
        mt: "+356 - mt",
        mu: "+230 - mu",
        nz: "+64 - nz",
        pa: "+507 - pa",
        sc: "+248 - sc",
        se: "+46 - se",
        tz: "+255 - tz",
        ve: "+58 - ve"
    },
    CountryNames: {
        uk: "United Kingdom",
        ie: "Ireland",
        az: "Azerbaidjan",
        bb: "Barbados",
        kh: "Cambodia",
        co: "Colombia",
        cr: "Costa Rica",
        cw: "Curacao",
        ec: "Ecuador",
        fk: "Falkland Islands",
        gh: "Ghana",
        gi: "Gibraltar",
        gg: "Guernsey",
        iq: "Iraq",
        im: "Isle of Man",
        je: "Jersey",
        lb: "Lebanon",
        mt: "Malta",
        mu: "Mauritius",
        nz: "New Zealand",
        pa: "Panama",
        sc: "Seychelles",
        se: "Sweden",
        tz: "Tanzania",
        ve: "Venezuela"
    },
    Deposit: "Deposit",
    DepositLimit: "Deposit Limit",
    DOB: "Date of Birth",
    EmailAdd: "Email Address",
    EnterPromoCode: "Enter Promo Code",
    EventCard: {
        backAll: "Back All",
        layAll: "Lay All",
        spHeader: "XSP"
    },
    Favourites: "Favourites",
    FName: "First Name",
    FundsProtection: "Funds Protection",
    FreeBet: "Free Bet",
    FreeBetsInValidSelections:
        "The selections specified are not valid with this Free Bet.<br/>Please review your Free Bet entitlements and change your selections to qualify.",
    FreeBetsExceedsMinPrice:
        "The selections specified are below the minimum price available for this Free Bet.<br/>Please review your Free Bet entitlement(s) and change your selections to qualify.",
    FreeBetsExceedsTotalStake:
        "The total stake exceeds Free Bets balance.<br/>Please review your Free Bet entitlements and change your stake(s) to qualify.",
    GameBlockedCountry: "This game is not available in your country",
    GameNotEnabled: "This game is not enabled for play on mobile devices",
    Games: "Games",
    Geoblocked: "Sorry, the feature you are trying to access is not available in your region",
    HNumber: "House Name/Number",
    Home: "Home",
    IfPlaced: "If Placed",
    IfUnPlaced: "If Unplaced",
    IfWins: "If Wins",
    InPlay: "In-Play",
    InvalidOddsEntered: [
        "The odds you have entered are invalid. Please try again",
        "Prices between 6.00 and 10.00 must be a multiple of 0.20",
        "Prices between 10.00 and 20.00 must be a multiple of 0.50",
        "Prices between 20.00 and 50.00 must be a multiple of 1.00",
        "Prices between 50.00 and 200.00 must be a multiple of 2.00",
        "Prices between 200.00 and 1000.00 must be a multiple of 5.00",
        "The maximum price is 1000.00",
        "The Fractional odds you have entered are invalid. Please try again."
    ],
    InvalidPromoCode: "Unfortunately, the promotion code you entered was not valid.",
    Join: "Join",
    JoinNow: "Join Now",
    KeepInPlay: "If unmatched at off,  will be kept In-Play.",
    Liability: "Liability",
    LiveStreaming: "Live Streaming",
    FootballStatistics: "Football Statistics",
    FootballStats: "Soccer Stats",
    LiveStreamingExposure:
        "Video unavailable - sorry but your account does not currently qualify to watch this race. Please place a bet to watch this race. Minimum matched bet: {0}",
    LiveStreamingExposureSportsbook:
        "Video unavailable - sorry but your account does not currently qualify to watch this race. Please place a bet to watch this race. Minimum bet: {0}",
    LiveStreamingNotStarted:
        "Video unavailable - sorry but coverage of this race will not be available until a few minutes before the race start time.",
    LiveVideo: "Live Video",
    StreamingGenericError: "We are sorry but streaming is not available on this race at the current time.  Please try again later or contact the helpdesk for further assistance.",
    NoStreamAvailable: "We are sorry but streaming is not available on this race at the current time.  Please try again later or contact the helpdesk for further assistance.",
    PunterNotQualified: "You must have placed a bet of at least {currencySymbol} {minExposure} (or currency equivalent) on the race you wish to view.  Please place your bet and try again.",
    eventover: "This event is over",
    LiveStreamIsReady: "The live stream is now ready. Please click on the link below to view the stream",
    LName: "Last Name",
    Login: "Login",
    Logout: "Logout",
    MarketPandL: "Market P&L",
    MatchedAmount: "Matched",
    MaxDepositMessage: "Max deposit limit: ",
    MaxFavs: "Sorry, you already have the maximum number of favourites: {0}",
    Minutes: "Minutes",
    Mobile: "Mobile Number",
    Multiples: "Multiples",
    MultiplesFreeBetsInValidSelections:
        "The selections specified are not valid with this Free Bet.<br/>Please review your Free Bet entitlements and change your selections to qualify.",
    MultiplesFreeBetsExceedsTotalStake:
        "The total stake exceeds Free Bets balance.<br/>Please review your Free Bet entitlements and change your stake(s) to qualify.",
    MultiplesFreeBetsNoMinLegs:
        "The selections specified do not meet minimum legs requirement for this Free Bet.<br/>Please review your Free Bet entitlements and change your selections.",
    MultiplesFreeBetsNoMinPrice:
        "The selections specified are below the minimum price available for this Free Bet.<br/>Please review your Free Bet entitlement(s) and change your selections to qualify.",
    MyBets: "My Bets",
    MyAccount: "My Account",
    BetFinder: "Bet Finder",
    NewGamesError: "There was an error retrieving the new games",
    NoGame: "Game not found",
    NoGamesFavourites: "There are no favourites",
    NoGames: "There are no games available in this group",
    NoGamesGroups: "There are no games groups available",
    None: "None",
    Odds: "Odds",
    OpenAc: "Open Account",
    Opta: "Opta",
    PartnerEnterPromoCode: "Hi {0}, Please enter your promotion code below to opt in.",
    Password: "Password",
    PerDay: "Per Day",
    PerWeek: "Per Week",
    PerMonth: "Per Month",
    PersonalDetails: "Personal Details",
    PlaceBet: "Place Bet",
    PlaceBets: "Place Bets",
    PlaceFreeBets: "Place Free Bets",
    PostCode: "Postcode/Zip Code",
    PotentialProfit: "Potential Profit",
    PopularLinks: "Popular Links",
    PromoCode: "Promotional Code",
    Profit: "Profit",
    PromotionCode: "Promotion Code",
    PromoCodeAdded: "Thank you. <br/><br/>The promotion code you entered has been successfully submitted",
    PromoCodeAlreadyUsed: "This promotion code has already been entered.",
    Promotions: "Promotions",
    PrvPolicy: "Privacy Policy",
    QFirstSchool: "What was the first school you attended?",
    QMothersName: "What was your mother's maiden name?",
    QWhereBorn: "Place of birth?",
    RacingForm: "Racing Form",
    RealityCheck: "Reality Check",
    ReconnectMessage: "Attempting to reconnect...",
    Reference: "Reference",
    RememberMe: "Remember Me",
    RememberUsername: "Remember Username",
    RenderError: "Sorry, there was a problem displaying the requested page. You will now be redirected to the homepage",
    ResponsibleGambling: {
        EnterPassword: "Please enter your Password:",
        IncorrectPassword: "The password was incorrect",
        SelfExclude: {
            GamstopText:
                "If you are considering self-exclusion, you may wish to register with GAMSTOP. <br /><br /> GAMSTOP is a free service that helps you self- exclude from all online gambling companies licenced in Great Britain. <br /><br /> To find out more and to sign up with GAMSTOP please visit <a href='https://www.gamstop.co.uk'>www.gamstop.co.uk</a><a class='host-legallink host-gamstop' target='gamstop' href='https://www.gamstop.co.uk/'>Gamstop</a>",
            AceSelfExclude: "AceKingdom: <a href='mailto:support@acekingdom.com'>support@acekingdom.com</a>",
            AlertMessage:
                "Thank you. You have now completed the self exclusion process and your BETDAQ account has been closed. We advise that you self-exclude from any other betting sites where you hold an account and that you use website filtering and / or blocking software to prevent you from accessing gambling websites from your personal computer.<br /><br />Should you require any further information please contact the helpdesk on +353 1 673 3360 or by emailing helpdesk@betdaq.com",
            AlertMessageUK:
                "Thank you. You have now completed the self exclusion process and your BETDAQ account has been closed. We advise that you self-exclude from any other betting sites where you hold an account and that you use website filtering and / or blocking software to prevent you from accessing gambling websites from your personal computer.<br /><br /><span class='gamstop-excluded'><span><br /><br/>To self-exclude from all online gambling companies licensed in Great Britain go to <a href='https://www.gamstop.co.uk'>www.gamstop.co.uk</a></span><a class='host-legallink host-gamstop' target='gamstop' href='https://www.gamstop.co.uk/'>Gamstop</a></span><br />Should you require any further information please contact the helpdesk on +353 1 673 3360 or by emailing helpdesk@betdaq.com",
            Close:
                "You can also close your BETDAQ account by calling the helpdesk on +353 1 673 3360 or by emailing helpdesk@betdaq.com. See <a href='http://betdaqhelp.custhelp.com/app/answers/detail/a_id/155/kw/responsible' target='_blank'>Responsible Gambling Information</a>.",
            CloseAccount1:
                "We will also take steps to close your account(s) for  <a target='_blank' href='https://gvc-plc.com/about/business-overview/our-brands/'>all UK brands</a>  within our group and remove your name and details from our marketing database(s) within 48 hours of receiving your self exclusion request.",
            BrandsList: {
                Title: "These brands include, but are not limited to:",
                li1: "<b> Sports </b>- BETDAQ, Bwin, Coral, Ladbrokes, Sportingbet,",
                li2: "<b> Casino </b>- Foxy Casino, Gala Casino, Gala Spins, Party Casino",
                li3: "<b> Bingo </b>- Foxy Bingo, Gala Bingo",
                li4: "<b> Poker </b>- Party Poker"
            },
            CloseAccount2: "You can also close your account by calling the helpdesk on 0870 1781 021 (UK) / 00353 15566222 (International) or by emailing helpdesk@betdaq.com.",
            Instruction: "In order to self-exclude, select a time period below and click Stop Betting.",
            ImportantNotice: "Important Notice",
            LadbrokesSelfExclude:
                "Ladbrokes: <a href='mailto:selfexclusion@ladbrokes.com'>selfexclusion@ladbrokes.com</a> and;",
            Text:
                "If you wish to exclude yourself from the BETDAQ service, please choose your timeframe below and press submit. You will then enter your BETDAQ password to confirm your request.",
            SeeResponsibleGambling: "See <a target='_blank' href='http://betdaqhelp.custhelp.com/app/answers/detail/a_id/155'> Responsible Gambling Information. </a>",
            SelfExcludeFor: "Please exclude me from betting for:",
            StopBetting: "Stop Betting",
            Title: "Self Exclusion",
            WhatHappens: {
                Footer:
                    "BETDAQ is operated by a Ladbrokes Group company and under the same gambling licences as both Ladbrokes (<a href='http://www.ladbrokes.com' target='_blank'>www.ladbrokes.com</a>) and Ace Kingdom (<a href='http://www.AceKingdom.com' target='_blank'>www.AceKingdom.com</a>).  As a consequence of this, we are obliged to forward your details to the self-exclusion teams at both Ladbrokes and AceKingdom who will close any account held with <a href='http://www.ladbrokes.com' target='_blank'>www.ladbrokes.com</a> and/or <a href='http://www.AceKingdom.com' target='_blank'>www.AceKingdom.com</a> with the same details. However, in order to ensure that your accounts held with <a href='http://www.ladbrokes.com' target='_blank'>www.ladbrokes.com</a> or <a href='http://www.AceKingdom.com' target='_blank'>www.AceKingdom.com</a> have been closed and subject to Ladbrokes� group self-exclusion procedure, we would also recommend that you should send an email to the following details:",
                li1: "You will be logged out of your account",
                li2: "All unmatched orders will be cancelled",
                li3: "We will take all reasonable measures to prevent you from using our services",
                li4: "We will not send you any marketing materials",
                li5: "You agree to refrain from attempting to place any bets with Betdaq",
                Title: "What happens when I exclude myself?"
            }
        },
        Title: "Responsible Gambling",
        Timeout: {
            AlertMessage:
                "Thank You. You have now completed a Time Out from your account with BETDAQ.  Please note that your account will automatically re-open when the period of the Time Out has expired.  Should you require any further information please contact the helpdesk on +353 1 673 3360 or by e-mailing helpdesk@betdaq.com",
            Instruction: "In order to Time Out, select a time period below and click Stop Betting.",
            Text:
                "You can opt to take a break from BETDAQ for a short period of time, during which you will not be able to avail of the BETDAQ Services.  Please note that the Time Out facility is not treated as a self exclusion but rather a facility to take a break.  Accordingly, BETDAQ will not receive nor share the details of your Time Out with any of the Ladbrokes Group companies and you agree that BETDAQ do not bear any responsibility for any consequences or circumstances arising to you during the period of the Time Out where the Time Out is circumvented either intentionally, accidentally or otherwise.",
            TimeoutFor: "I want to Time Out for:",
            Title: "Time Out",
            WhatHappens: {
                Footer:
                    "You can choose any one of the periods outlined below and when the period of the Time Out has elapsed, you will be able to access the BETDAQ services again.",
                li1: "You will be logged out of your account",
                li2: "All unmatched orders will be cancelled",
                li3: "We will take all reasonable measures to prevent you from using our services",
                li4: "We will not send you any marketing materials",
                li5: "You agree to refrain from attempting to place any bets with Betdaq",
                Title: "What happens when I Time Out?"
            }
        },
        SetDepositLimit: {
            Title: "Set Deposit Limit"
        }
    },
    Results: "Results",
    Rules: "Rules",
    SecQuestion: "Security Question",
    SelfExclusion: "Self Exclusion",
    SetDepositLimit: "Set Deposit Limit",
    Settings: "Settings",
    sports: {
        greyhoundRacing: "Greyhound Racing",
        horseRacing: "Horse Racing",
        soccer: "Soccer"
    },
    Standard: "Standard",
    Street1: "Street Address 1",
    Stake: "Stake",
    Street2: "Street Address 2",
    TakeXSP: "If unmatched at off, bets will be matched at Exchange Starting Price.",
    Terms: "Terms &amp; Conditions",
    Title: "Title",
    TodaysLive: "Today's Live",
    TotalEachWayStake: "Total E/W Stake",
    UName: "Username",
    UpdateBet: "Update Bet",
    visualizations: {
        period: {
            "-": "-",
            "1": "Not Started",
            "2": "1st Half",
            "4": "Half Time",
            "8": "2nd Half",
            "16": "Finished",
            "32": "Regular Time Finished",
            "64": "1st Half Extra Time",
            "128": "Half Time of Extra Time",
            "256": "2nd Half Extra Time",
            "512": "Extra Time Finished",
            "1024": "Penalty Shootout"
        }
    },
    Virtuals: "Virtuals",
    VirtualSports: "Virtual Sports",
    Withdraw: "Withdraw",
    YourOdds: "Your Odds",
    Single: "Single ({0})",
    Double: "Double ({0} Bet)",
    Treble: "Treble ({0} Bet)",
    FourFold: "Four Fold ({0} Bet)",
    FiveFold: "Five Fold ({0} Bet)",
    SixFold: "Six Fold ({0} Bet)",
    SevenFold: "Seven Fold ({0} Bet)",
    EightFold: "Eight Fold ({0} Bet)",
    NineFold: "Nine Fold ({0} Bet)",
    TenFold: "Ten Fold ({0} Bet)",
    ElevenFold: "Eleven Fold ({0} Bet)",
    TwelveFold: "Twelve Fold ({0} Bet)",
    ThirteenFold: "Thirteen Fold ({0} Bet)",
    FourteenFold: "Fourteen Fold ({0} Bet)",
    FifteenFold: "Fifteen Fold ({0} Bet)",
    SixteenFold: "Sixteen Fold ({0} Bet)",
    SeventeenFold: "Seventeen Fold ({0} Bet)",
    EighteenFold: "Eighteen Fold ({0} Bet)",
    NineteenFold: "Nineteen Fold ({0} Bet)",
    TwentyFold: "Twenty Fold ({0} Bet)",

    "Singles": "Singles ({0} Bets)",
    Doubles: "Doubles ({0} Bets)",
    Trebles: "Trebles ({0} Bets)",
    FourFolds: "Four Folds ({0} Bets)",
    FiveFolds: "Five Folds ({0} Bets)",
    SixFolds: "Six Folds ({0} Bets)",
    SevenFolds: "Seven Folds ({0} Bets)",
    EightFolds: "Eight Folds ({0}) Bets",
    NineFolds: "Nine Folds ({0}) Bets",
    TenFolds: "Ten Folds ({0}) Bets",
    ElevenFolds: "Eleven Folds ({0}) Bets",
    TwelveFolds: "Twelve Folds ({0}) Bets",
    ThirteenFolds: "Thirteen Folds ({0}) Bets",
    FourteenFolds: "Fourteen Folds ({0}) Bets",
    FifteenFolds: "Fifteen Folds ({0}) Bets",
    SixteenFolds: "Sixteen Folds ({0} Bet)",
    SeventeenFolds: "Seventeen Folds ({0} Bet)",
    EighteenFolds: "Eighteen Folds ({0} Bet)",
    NineteenFolds: "Nineteen Folds ({0} Bet)",
    TwentyFolds: "Twenty Folds ({0} Bet)",

    "Single0": "Single",
    "Double0": "Double",
    "Treble0": "Treble",
    "FourFold0": "Four Fold",
    "FiveFold0": "Five Fold",
    "SixFold0": "Six Fold",
    "SevenFold0": "Seven Fold",
    "EightFold0": "Eight Fold",
    "NineFold0": "Nine Fold",
    "TenFold0": "Ten Fold",
    "ElevenFold0": "Eleven Fold",
    "TwelveFold0": "Twelve Fold",
    "ThirteenFold0": "Thirteen Fold",
    "FourteenFold0": "Fourteen Fold",
    "FifteenFold0": "Fifteen Fold",
    "SixteenFold0": "Sixteen Fold",
    "SeventeenFold0": "Seventeen Fold",
    "EighteenFold0": "Eighteen Fold",
    "NineteenFold0": "Nineteen Fold",
    "TwentyFold0": "Twenty Fold",

    "Accumulator": "Accumulator ({0} Bet)",
    "Accumulators": "Accumulator ({0} Bets)",
    "nDoubles": "{0} Doubles ({0} Bets)",
    "nTrebles": "{0} Trebles ({0} Bets)",
    "nFourFolds": "{0} Four Folds ({0} Bets)",
    "nFiveFolds": "{0} Five Folds ({0} Bets)",
    "nSixFolds": "{0} Six Folds ({0} Bets)",
    "nSevenFolds": "{0} Seven Folds ({0} Bets)",
    "nEightFolds": "{0} Eight Folds ({0} Bets)",
    "nNineFolds": "{0} Nine Folds ({0} Bets)",
    "nTenFolds": "{0} Ten Folds ({0} Bets)",
    "nElevenFolds": "{0} Eleven Folds ({0} Bets)",
    "nTwelveFolds": "{0} Twelve Folds ({0} Bets)",
    "nThirteenFolds": "{0} Thirteen Folds ({0} Bets)",
    "nFourteenFolds": "{0} Fourteen Folds ({0} Bets)",
    "nFifteenFolds": "{0} Fifteen Folds ({0} Bets)",
    "nSixteenFolds": "{0} Sixteen Folds ({0} Bet)",
    "nSeventeenFolds": "{0} Seventeen Folds ({0} Bet)",
    "nEighteenFolds": "{0} Eighteen Folds ({0} Bet)",
    "nNineteenFolds": "{0} Nineteen Folds ({0} Bet)",
    "nTwentyFolds": "{0} Twenty Folds ({0} Bet)",

    "nDouble": "{0} Double",
    "nTreble": "{0} Treble",
    "nFourFold": "{0} Four Fold",
    "nFiveFold": "{0} Five Fold",
    "nSixFold": "{0} Six Fold",
    "nSevenFold": "{0} Seven Fold",
    "nEightFold": "{0} Eight Fold",
    "nNineFold": "{0} Nine Fold",
    "nTenFold": "{0} Ten Fold",
    "nElevenFold": "{0} Eleven Fold",
    "nTwelveFold": "{0} Twelve Fold",
    "nThirteenFold": "{0} Thirteen Fold",
    "nFourteenFold": "{0} Fourteen Fold",
    "nFifteenFold": "{0} Fifteen Fold",
    "nSixteenFold": "{0} Sixteen Fold",
    "nSeventeenFold": "{0} Seventeen Fold",
    "nEighteenFold": "{0} Eighteen Fold",
    "nNineteenFold": "{0} Nineteen Fold",
    "nTwentyFold": "{0} Twenty Fold",

    "Bet": "Bet",
    "Bets": "Bets",

    ThreeTimer: "Trixie ({0} Bets)",
    FourTimer: "Yankee ({0} Bets)",
    FiveTimer: "Super Yankee ({0} Bets)",
    SixTimer: "Heinz ({0} Bets)",
    SevenTimer: "Super Heinz  ({0} Bets)",
    EightTimer: "Eight Timer ({0} Bets)",
    NineTimer: "Nine Timer ({0} Bets)",
    TenTimer: "Ten Timer ({0} Bets)",
    Patent: "Patent ({0} Bets)",
    Lucky15: "Lucky 15 ({0} Bets)",
    Lucky31: "Lucky 31 ({0} Bets)",
    Lucky63: "Lucky 63 ({0} Bets)",
    Goliath: "Goliath ({0} Bets)",
    CustomMultipleRC:
    {
        1: "An error has occured and the system has not been able to complete the operation you requested. Please contact the help desk.",
        2: "There was an error and the status of your bet is unconfirmed. Please view your 'Current Bets' to check if the bet has been confirmed or not.",
        15: "The action requested cannot be performed because the market specified is not active. Please refresh the market.",
        17: "The action requested cannot be performed because a selection specified is not active. Please refresh the market.",
        302: "The Bet requested could not be placed. Please refresh the market & try again."
    },

    Messages:
    {
        ExceptionLoggingIn: "An issue has occurred logging into the game. Please contact the help desk.",
        ExceptionSettingUserContext: "An issue has occurred logging into the game. Please contact the help desk.",
        /*ExceptionGettingBalance: "An error has occured and the system has not been able to complete the operation you requested. Please contact the help desk.",*/
        InsufficientFreeBetStakeAvailable: "No bets have been placed, since your Free Bet entitlements are not sufficient to cover the stake (Back bets) or liability (Lay bets) for all of the requested bets, or cannot be used for the requested bets.<br /><br />Please try placing the bets from your normal betting funds instead, or reducing the stake/liability.",
        NoBetsSubmitted: "No bets submitted",
        ConfirmFreeBetSubmission: "Note: Unmatched free bets cannot be changed once placed. If your free bet remains unmatched and you wish to change the odds or stake please cancel your unmatched free bet and place another bet using the returned free bet balance. {0}<br/><br/>Do you wish to place your free bets?",
        ConfirmSingleFreeBetSubmission: "\n\nIf you place bets using a free bet entitlement marked 'Single Bet', any unused portion of the free bet entitlement will lapse. Also, if you subsequently cancel such a bet, or it is never matched, then the free bet entitlement cannot be reused.\n",
        GeneralIAPIError: "An error has occured and the system has not been able to complete the operation you requested. Please contact the help desk."

    },
    OrderStatus:
    {
        Matched: "Matched",
        PartMatched: "Part Matched",
        Unmatched: "Unmatched",
        Cancelled: "Cancelled",
        Expired: "Cancelled",
        Settled: "Settled",
        Voided: "Voided",
        Suspended: "Suspended"
    },
    ReturnCodes:
    {
        0: "Success",
        1: "Resource Error",
        2: "An error has occured and the system has not been able to complete the operation you requested. Please contact the help desk.",
        11: "SelectionDoesNotExist",
        15: "The action requested cannot be performed because the market specified is not active. Please refresh the market.",
        16: "This market is no longer available for betting.",
        17: "We are no longer accepting bets on this selection.",
        21: "Order Does Not Exist.",
        22: "Your bet status has changed, please check your current bets",
        23: "Currency Not Valid",
        25: "We're sorry, we cannot process this request as it would result in your potential losses on this market exceeding your limit.",
        48: "Invalid country code (for example: uk, fr, de, etc.)",
        66: "Currency Not Supported",
        71: "Language Does Not Exist",
        114: "The market was reset just as you were trying to place the bet. Markets are reset when something happens that could affect the odds being offered, for example when a goal is scored. Please try again.",
        131: "Invalid Odds. Please try again.",
        136: "Selection(s) in one of the market(s) is withdrawn just as you were trying to place the bet.Please try again.",
        201: "Punter Does Not Exist",
        203: "Nostro Vostro Account Already Exists",
        204: "FTMR Does Not Exist",
        205: "FTMR Not Known To Issuer",
        206: "Payment Declined By Issuer",
        207: "Payment Bridge Not Available",
        208: "Your account has been suspended. Please contact the help desk.",
        211: "Punter Username Already Exists",
        213: "Punter Has Orders",
        214: "Punter Already Active",
        215: "Punter Already Suspended",
        240: "Your bet was not placed because your account has been suspended. Please contact the help desk.",
        241: "We're sorry, but you do not have sufficient funds in your account to process this request.",
        242: "Your funds have not been transferred because you requested an amount greater than your balance. Specify a smaller amount and re-try the transfer.",
        267: "Invalid Username",
        271: "Order API In Progress",
        288: "Your bet has not been placed as these odds are no longer available",
        289: "Your bet has not been placed as these odds are no longer available",
        302: "Punter Is Suspended From Trading",
        305: "Expiry Time In The Past",
        314: "Punter Restricted From AgainstSideOrders",
        315: "Punter Restricted From ForSideOrders",
        316: "Punter Restricted To Fill Kill Orders",
        406: "Punter Is Blacklisted",
        435: "MarketNotEnabledForOU",
        441: "The payout has already been paid.",
        442: "The bet is not a winning bet and so no payout is due.",
        443: "The bet has not yet been settled, please try again later.",
        444: "MarketNotEnabledForOULocalBets",
        450: "MarketNotEnabledForEachWay",
        454: "Your bet was not placed because we are no longer accepting bets on that outcome at the odds shown.",
        473: "Threshold Specified Too Small",
        486: "Expired T And C Version",
        489: "We're sorry, but your bet could not be placed. Please try again, or contact customer service.",
        493: "There has been an issue validating your account.  Please contact the <a href='{0}'>helpdesk</a> for assistance.",
        494: "There has been an issue validating your account.  Please contact the <a href='{0}'>helpdesk</a> for assistance.",
        495: "The bet was not placed because you do not have sufficient funds to cover the bet.",
        496: "There has been an issue connecting to the system.  Please try again or contact the <a href='{0}'>helpdesk</a> for assistance.",
        497: "PIC Currency Not Valid",
        500: "Punter Not Registered To Integration Partner",
        503: "Integration Partner Name Already Exists",
        505: "Terms And Conditions Already Exists",
        506: "Terms And Conditions Does Not Exist",
        511: "PartnerToken Not Authenticated",
        512: "SessionToken Not Authenticated",
        514: "SessionToken No Longer Valid",
        518: "Username Does Not Exist",
        519: "Maximum Output Records Exceeded",
        521: "Password Authentication Not Allowed",
        555: "IsLineBetting",
        579: "EachWayLayBetsNotAllowed",
        584: "PartnerTelebetTokenNotAuthenticated",
        585: "TelebetSessionTokenNotAuthenticated",
        586: "Not Sessionless",
        587: "Not Telebet Session",
        588: "Not Telebet UserSession",
        589: "Not User Session",
        590: "You are not logged in.",
        591: "Defaults Not Loaded",
        596: "StakeOutsideAcceptableRange",
        597: "MarketIsForRealMoney",
        599: "MarketIsForPlay",
        612: "Punter Not Authenticated",
        617: "Punter Is Currently Logged In",
        644: "No bets have been placed, since your Free Bet entitlements are not sufficient to cover the stake (Back bets) or liability (Lay bets) for the requested bets, or cannot be used for the requested bets.<br/><br/>Please try to place the bets from your regular betting funds instead, or reduce the stake/liability.",
        812: "The bet you have requested is currently not available. Please check your bet and try again.",
        813: "The market you have selected is currently not active.  Please check your bet and try again.",
        814: "The  selection you have requested is not active.  Please check your bet and try again.",
        815: "The price you have requested is currently not available.  Please check your bet and try again.",
        828: "The price you have requested is currently not available.  Please check your bet and try again.",
        829: "The bet you have requested is currently not available.  Please check your bet and try again.",
        885: "This market is not enabled for Exchange Starting Price.",
        886: "An error has occured and the system has not been able to complete the operation you requested. Please contact the help desk.",
        887: "Sorry, your account is not enabled for Exchange Starting Price.",
        892: "The bet you have requested cannot be enabled for Exchange Starting Price."
    },
    multiplebetslip: {
        selectprice: "To select a bet click on any price.",
        mintwoselections: "You must choose a minimum of two selections in order to place a multiple.",
        maxStake: "At this price, the max stake allowed is  {0}.",
        includeIn: "Include in multiples",
        clear: "Clear Multiple",
        confirm: "Confirm bets before placing",
        retain: "Retain selections after bet placement",
        invalid: "For this multiple bet, the stake is invalid",
        minlinestake: "The minimum stake per line allowed is {0}{1}",
        minstake: "The minimum total stake allowed is {0}{1}",
        noPriceAvailableForCombination: "No price available for this combination",
        confirmbets1: "Confirm bet(s)",
        confirmbets2: "You are about to place the following bet(s)",
        receiptbets1: "Bet Receipt",
        receiptbets2: "Multiple bet(s) placed",
        receiptbets3: "Multiple bet(s) NOT placed",
        receiptbets4: "Multiple Free Bet(s) placed",
        mbetslip: "MULTIPLES Betslip",
        mconfirm: "MULTIPLES Confirm",
        mreceipt: "MULTIPLES Receipt",
        maxNumberOfSelection: "You can only have {0} selections in a multiple bet, please uncheck a selection to continue."
    },
    SportRadar: {
        NoTournamentInformationAvailable: "No tournament information available"
    },
    ReCAPTCHATokenNotValid: "You cannot be logged in at the moment. Please contact helpdesk",
    ReCAPTCHATokenRequired: "You cannot be logged in at the moment. Please contact helpdesk",
    TwoFactorAuthenticationCodeNotValid: "Wrong code entered.",
    TwoFactorAuthenticationDeviceNameAlreadyUsedWindowTitle: "Failed to add trusted device",
    TwoFactorAuthenticationDeviceNameAlreadyUsedWindowDescription: "Device name already exists.",
    TwoFactorAuthenticationLoginWindowTitle: "Two-Step Authentication",
    TwoFactorAuthenticationLoginWindowDescription: "Open the Google Authenticator app on your phone and type the verification code into the box below",
    TwoFactorAuthenticationLoginWindowThisIsATrustedDevice: "This is a trusted device",
    TwoFactorAuthenticationLoginWindowDeviceNamePlaceholder: "Name",
    TwoFactorAuthenticationLoginWindowDeviceTypePhone: "Phone",
    TwoFactorAuthenticationLoginWindowDeviceTypeTablet: "Tablet",
    TwoFactorAuthenticationLoginWindowDeviceTypeLaptop: "Laptop",
    TwoFactorAuthenticationLoginWindowDeviceTypeDesktop: "Desktop",
    TwoFactorAuthenticationLoginWindowVerify: "Verify",
    groupTitles: {
        "-1": "All Markets",
        "1": "All Win Markets",
        "2": "All Place Markets",
        "3": "All Match Odds Markets",
        "4": "All Over/Under Markets",
        "10": "All Asian Handicaps",
        "13": "All Unspecified Markets",
        "14": "All Match Markets",
        "15": "All Set Markets",
        "16": "All Money Line",
        "17": "All Totals",
        "18": "All Handicaps"
    }
};

export default resources_en;
